module.exports = __webpack_public_path__ + "img/logowp.b31838e8.png";